<template>
    <div>
        <div class="list-group list-group-fill-success">
            <a v-for="(file, fIndex) in files" :key="fIndex" :href="file.path" target="_blank"
                class="list-group-item d-flex align-items-center p-0 list-group-item-action">
                <div class="p-2">
                    <img style="width: 24px;" :src="absoluteUrl(`/images/file-icons/${file.extension}.svg`)" class="">
                </div>
                <div class="p-2 border-start flex-grow-1 small border-end">
                    {{ file.filename }}
                </div>
                <div class="p-2">
                    <i class="ri-download-2-fill text-primary align-middle"></i>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        files: {
            type: Array,
            required: () => []
        }
    },
}
</script>

<style></style>